import { Component, OnInit, Input, Inject } from '@angular/core';
import { Order } from 'src/app/models/virtual-store/order.model';
import { OrderState } from 'src/app/models/virtual-store/order-state.model';
import { OrderItemService } from 'src/app/services/order-item.service';
import { DetailedOrderItem } from 'src/app/models/virtual-store/detailed-order-item.model';
import { ProductCategory } from 'src/app/models/virtual-store/product-category.model';
import { ValuableProductCategory } from 'src/app/models/virtual-store/valuable-product-category.model';
import { MAT_DIALOG_DATA } from '@angular/material';
import { OrderFnb } from 'src/app/models/virtual-store/orderFnb.model';
import { AppConstant } from 'src/app/constants/app.constant';

@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss']
})
export class OrderDetailComponent implements OnInit {
  order: Order;
  orderFnb:OrderFnb
  orderStateList: OrderState[];
  orderItemList: DetailedOrderItem[] = [];
  valuableCategoryList: ValuableProductCategory[] = [];
  valuableCategoryListFnb: ValuableProductCategory[] = [];
  CategoryFnbList:string[];
  isCreditLineFnb:boolean  
  orderStateListFnb: OrderState[] = [];
  codeFilterFnb:string=AppConstant.FNB;  
  constructor(@Inject(MAT_DIALOG_DATA) private input: any, private orderItemService: OrderItemService) { }

  ngOnInit() {
    this.isCreditLineFnb=this.input.isFnb;    
    if(this.isCreditLineFnb){
      this.orderFnb=this.input.order;          
      this.loadCategoryFnb();
    }else{
      this.order = this.input.order;
      this.orderStateList = this.input.orderStateList;
      this.listOrderItems();
    }
    
  }

  listOrderItems() {
    this.orderItemService.list(this.order.id).subscribe(response => {
      if (response.valid) {
        this.orderItemList = response.data;
        this.getCategoryList();
      }
    })
  }
  getCategoryList() {
    this.valuableCategoryList = this.orderItemList.map(item => new ValuableProductCategory(item.product.category));
    this.valuableCategoryList = Array.from(new Set(this.valuableCategoryList.map(s => JSON.stringify(s)))).map(item => JSON.parse(item));
    this.updateCategoryListAmounts();
  }
  updateCategoryListAmounts() {
    this.valuableCategoryList.map(valuableCategory => {
      valuableCategory.amount = this.getTotalAmountByCategory(valuableCategory.category);
      return valuableCategory;
    });
  }
  getTotalAmountByCategory(category: ProductCategory) {
    if (this.orderItemList != null && this.orderItemList.length > 0) {
      return this.orderItemList.filter(x => x.product.category.code == category.code).map(x => x.product.price * x.count).reduce(function (previous, current) {
        return previous + current;
      });
    } else { return 0; }
  }
  loadCategoryFnb(){
     this.CategoryFnbList=this.orderFnb.orderFnbDetail.map(item=>item.category).filter((value, index, self) => self.indexOf(value) === index);     
  }  
  getStatesFnb(idEstado : any){
    this.orderStateListFnb=
        [          
          {"id":1,
           description:"Pendiente de Entrega"
          }       
        ];    
    if(idEstado > 1){
      let estado={"id":this.orderFnb.stateId,
                  "description":this.orderFnb.stateName}
      this.orderStateListFnb.push(estado);
    }else{
      let estado={"id":2,
                  "description":"Entregado"}
      this.orderStateListFnb.push(estado);
    }     
    return this.orderStateListFnb;
  }  
}
